
// 标的所在地
export const addrOptions = [
  { label: '县内', value: '1' },
  { label: '县外', value: '2' },
]
// 交易方式
export const payOptions = [
  { label: '竞拍', value: '1' },
  { label: '非竞拍', value: '2' },
  { label: '预售', value: '3' },
]
// 林地属性
export const forestOptions = [
  { label: '国有', value: '1' },
  { label: '非国有', value: '2' },
]

// 拍卖状态
export const projectPropertiesOptions = [
  { label: '全部', value: '' },
  { label: '受让', value: '受让' },
  { label: '转让', value: '转让' },
  { label: '合股', value: '合股' },
  { label: '租赁', value: '租赁' },
  { label: '出租', value: '出租' },
  { label: '土地信托', value: '土地信托' },
  { label: '出售', value: '出售' },
  { label: '拍卖', value: '拍卖' }
]
